// extracted by mini-css-extract-plugin
module.exports =  {"chat-btn":"_93444fe79c--chat-btn--oUzLI"};